<template>
  <div
    id="printMe"
  >
    <div
      class="A3 portrait container mt-4"
    >
      <button
        v-show="false"
        ref="printButton"
        v-print="printObj"
      >
        Print
      </button>

      <poster-design
        :data="voucher"
        :qr-data="url"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PosterDesign from './PosterDesign.vue'

export default {
  components: {
    PosterDesign,
  },
  data() {
    const cssExtra = [
      'https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.css',
    ]

    return {
      qrData: {
        value: 'https://example.com',
      },
      printLoading: true,
      printObj: {
        id: 'printMe',
        popTitle: 'Cetak Poster',
        extraCss: cssExtra.toString(),
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        beforeOpenCallback(vue) {
          // eslint-disable-next-line no-param-reassign
          vue.printLoading = true
        },
        openCallback(vue) {
          // eslint-disable-next-line no-param-reassign
          vue.printLoading = false
        },
        // eslint-disable-next-line no-unused-vars
        closeCallback() {
          window.close()
        },
      },
    }
  },
  computed: {
    ...mapState('voucher', ['voucher']),
    voucherId() {
      return this.$route.params.id
    },
    url() {
      return {
        value: `${process.env.VUE_APP_CLIENT_URL}/voucher/claim/${this.voucherId}`,
      }
    },
  },
  async created() {
    try {
      await this.getVoucherDetail({ voucherId: this.voucherId })
      await this.$nextTick(() => {
        this.$refs.printButton.click()
      })
    } catch (error) {
      this.$swal({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        timer: 3000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
  },
  methods: {
    ...mapActions('voucher', ['getVoucherDetail']),
  },
}
</script>

<style lang="scss" scoped>
* {
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
    color-adjust: exact !important;                 /*Firefox*/
}

@page {
    size: A3 portrait;
    // margin: 0;
}
</style>
